<template lang="html">
  <div v-if="filterDateRangeTimestamps && custom_claims" class="stat-panel">
    <div class="stat-icon-dim-bg">
      <img src="../assets/img/whycare-question-mark.svg" alt="?" />
    </div>
    <div class="stat-panel-data">
      <p class="loading" v-if="loading"><i class="far fa-fw fa-pulse fa-spinner"></i></p>
      <h1 v-if="pct !== null">{{ pct }}%</h1>
      <h4 v-if="pct !== null" class="light-weight">of Appointments Used Why/Care Encounters</h4>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import {mapGetters} from 'vuex'
import moment from 'moment-timezone';

export default {
  props: ['filterDateRangeTimestamps', 'filterPrimaryProvider', 'filterSecondaryProvider', 'filterAssistant'],
  data() {
    return {
      pct: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(['user', 'user_props', 'custom_claims']),
   
  },
  watch: {
    custom_claims(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.loadWhyCareAppointmentPct();
      }
    },
    filterDateRangeTimestamps: {
      handler(newVal, oldVal) {
        if(newVal !== oldVal) {
          this.loadWhyCareAppointmentPct();
        }
      },
      deep: true
    },
    filterPrimaryProvider(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.loadWhyCareAppointmentPct();
      }
    },
    filterSecondaryProvider(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.loadWhyCareAppointmentPct();
      }
    },
    filterAssistant(newVal, oldVal) {
      if(newVal !== oldVal) {
        this.loadWhyCareAppointmentPct();
      }
    },
  },
  methods: {
    // write method to call callable cloud function loadWhyCareAppointmentPct using filterDateRangeTimestamps and other required parameters
    async loadWhyCareAppointmentPct() {
      // validate data
      if(!this.custom_claims || !this.custom_claims.customerId || !this.custom_claims.authorized_location || !this.user || !this.user.uid || !this.filterDateRangeTimestamps || !this.filterDateRangeTimestamps.start || !this.filterDateRangeTimestamps.end) {
        console.error('Missing required data');
        return false;
      }
      this.loading = true;
      this.pct = null;
      try {
        const loadWhyCareAppointmentPct = Vue.functions.httpsCallable('loadWhyCareAppointmentPct');
        const response = await loadWhyCareAppointmentPct({
          // uid, customerId, locationId
          uid: this.user.uid,
          customerId: this.custom_claims.customerId,
          locationId: this.custom_claims.authorized_location,
          timestampStart: this.filterDateRangeTimestamps.start,
          timestampEnd: this.filterDateRangeTimestamps.end,
          provider: this.filterPrimaryProvider || null,
          hygieneProvider: this.filterSecondaryProvider || null,
          assistant: this.filterAssistant || null,
        });
        this.pct = response.data;
      } catch (error) {
        console.error('Error calling loadWhyCareAppointmentPct:', error);
        return null;
      } finally {
        this.loading = false;
      }
    },

  },
  mounted() {
    this.loadWhyCareAppointmentPct();
  },
}
</script>

<style lang="less" scoped>
</style>
